module.exports = __webpack_public_path__ + "img/site-belenes-alt1.6769afdb.jpg";